module.exports = __webpack_public_path__ + "static/media/download.2b33b3c1.svg";